
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button, notification } from 'ant-design-vue';
import Offer from '@/models/Offer';
import { Action } from 'vuex-class';

@Component({
    name: 'ResendPreorderOrderButton',
    components: { Button },
})
export default class ResendPreorderOrderButton extends Vue {
    @Action('projectLoadingState/updateAreOffersLoading') private updateAreOffersLoading!: (newState: boolean) => void;

    @Prop({ default: null }) private selectedOfferId!: string | null;

    private async resendOrder() {
        if (this.selectedOfferId == null) {
            return;
        }
        this.updateAreOffersLoading(true);
        try {
            await Offer.resendPreorderOrder(this.selectedOfferId);
            notification.success({
                message: this.$t('Success') as string,
                description: this.$t('Order resent successfully') as string,
            });
        } catch (e) {
            notification.error({
                message: this.$t('Error') as string,
                description: this.$t('Something went wrong resending the order') as string,
            });
        } finally {
            this.updateAreOffersLoading(false);
        }
    }
}
